/* ==========================================================================
   RATAJ WATCHES — number-picker.js
   iOS UIPicker-style wheel bound to live Shopify variant inventory.
   ========================================================================== */
(function () {
  'use strict';
  var ITEM_H = 48; // must match .wheel__item height in base.css

  /* wstrzyknięty override: wyłącza natywny scroll-snap i smooth na torze,
     które powodowały drganie na mobile i blokowanie szybkiego scrolla na PC */
  if (!document.getElementById('rtj-wheel-css')) {
    var st = document.createElement('style');
    st.id = 'rtj-wheel-css';
    st.textContent = '.wheel__track{scroll-snap-type:none;scroll-behavior:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch}.wheel__item{scroll-snap-align:none;transition:color .15s ease,opacity .15s ease}.wheel__item.is-active{transform:none}';
    document.head.appendChild(st);
  }

  document.querySelectorAll('[data-picker]').forEach(function (root) {
    var trigger   = root.querySelector('[data-picker-open]');
    var sheet     = root.querySelector('[data-picker-sheet]');
    var track     = root.querySelector('[data-wheel-track]');
    var valueEls  = root.querySelectorAll('[data-picker-value]');
    var doneBtn   = root.querySelector('[data-picker-done]');
    var scrim     = root.querySelector('[data-picker-scrim]');
    var addBtn    = root.querySelector('[data-add-to-cart]');
    var grid      = root.querySelector('[data-num-grid]');
    var gridToggle= root.querySelector('[data-grid-toggle]');
    if (!track) return;

    var items = Array.prototype.slice.call(track.querySelectorAll('.wheel__item'));
    var current = null; // {id, number, el}

    /* ---------- selection helpers ---------- */
    function setActive(idx) {
      items.forEach(function (it, i) { it.classList.toggle('is-active', i === idx); });
    }
    function commit(idx) {
      var it = items[idx];
      if (!it) return;
      current = { id: it.getAttribute('data-variant-id'), number: it.getAttribute('data-number'), idx: idx };
      valueEls.forEach(function (v) { v.textContent = current.number; });
      if (addBtn) {
        addBtn.removeAttribute('disabled');
        addBtn.setAttribute('data-variant-id', current.id);
      }
      if (grid) grid.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-selected', b.getAttribute('data-variant-id') === current.id);
      });
    }
    function nearestIdx() {
      var idx = Math.round(track.scrollTop / ITEM_H);
      return Math.max(0, Math.min(items.length - 1, idx));
    }
    function scrollToIdx(idx, smooth) {
      track.scrollTo({ top: idx * ITEM_H, behavior: smooth ? 'smooth' : 'auto' });
      setActive(idx);
    }

    /* ---------- swobodny scroll, snap po zatrzymaniu (rAF-throttle) ---------- */
    var snapT, ticking = false, lastIdx = -1;
    track.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () {
          var idx = nearestIdx();
          if (idx !== lastIdx) { setActive(idx); lastIdx = idx; }
          ticking = false;
        });
      }
      clearTimeout(snapT);
      snapT = setTimeout(function () {
        var idx = nearestIdx();
        if (Math.abs(track.scrollTop - idx * ITEM_H) > 1) {
          track.scrollTo({ top: idx * ITEM_H, behavior: 'smooth' });
        }
        setActive(idx);
        commit(idx);
      }, 110);
    }, { passive: true });

    /* tap an item to select it directly */
    items.forEach(function (it, i) {
      it.addEventListener('click', function () { scrollToIdx(i, true); commit(i); });
    });

    /* ---------- open / close sheet ---------- */
    function openSheet() {
      if (!sheet) return;
      sheet.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var idx = current ? current.idx : 0;
      requestAnimationFrame(function () { scrollToIdx(idx, false); });
    }
    function closeSheet() {
      if (!sheet) return;
      sheet.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    if (trigger) trigger.addEventListener('click', openSheet);
    if (doneBtn) doneBtn.addEventListener('click', closeSheet);
    if (scrim) scrim.addEventListener('click', closeSheet);

    /* ---------- optional grid ---------- */
    if (grid) grid.querySelectorAll('button:not([disabled])').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-variant-id');
        var idx = items.findIndex(function (it) { return it.getAttribute('data-variant-id') === id; });
        if (idx >= 0) { commit(idx); scrollToIdx(idx, false); }
      });
    });
    if (gridToggle && grid) gridToggle.addEventListener('click', function () {
      var open = grid.hasAttribute('hidden');
      if (open) { grid.removeAttribute('hidden'); gridToggle.textContent = gridToggle.getAttribute('data-less'); }
      else { grid.setAttribute('hidden', ''); gridToggle.textContent = gridToggle.getAttribute('data-more'); }
    });

    /* ---------- default selection (first available) ---------- */
    if (items.length) commit(0);

    /* ---------- ADD TO CART → /cart ---------- */
    if (addBtn) addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!current) return;
      var orig = addBtn.innerHTML;
      addBtn.setAttribute('disabled', '');
      addBtn.innerHTML = addBtn.getAttribute('data-loading') || 'Rezerwuję…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: current.id, quantity: 1 })
      })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          addBtn.innerHTML = orig;
          addBtn.removeAttribute('disabled');
          var msg = root.querySelector('[data-picker-error]');
          if (msg) { msg.hidden = false; }
          else { alert((res.d && res.d.description) || 'Ten numer został właśnie zarezerwowany. Wybierz inny.'); }
          return;
        }
        if (window.rtjRefreshCart) window.rtjRefreshCart();
        window.location.href = (window.routes_cart_url || '/cart');
      })
      .catch(function () {
        addBtn.innerHTML = orig;
        addBtn.removeAttribute('disabled');
      });
    });
  });
})();
